import { ChevronRight, LogOut, User, Building, CreditCard } from 'lucide-react';
import { useProfile } from '../../../../context/profile/ProfileContext';

const ProfileHeader = () => {
  const {
    activeTab,
    handleTabClick,
    isEditing,
    setIsEditing,
    handleSave,
    handleLogout,
    navigate
  } = useProfile();

  const tabs = [
    { id: 'account', label: 'Account', icon: User },
    { id: 'business', label: 'Business', icon: Building },
    { id: 'subscription', label: 'Subscription', icon: CreditCard }
  ];

  return (
    <>
      {/* Dynamic Page Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 py-1 sm:py-2">
        <div>
          <h1 className="text-lg sm:text-2xl font-black text-[#067978] tracking-tight uppercase">
            {activeTab === 'subscription' ? 'SUBSCRIPTION MANAGEMENT' : 'COMPANY PROFILE'}
          </h1>
          <p className="text-xs text-slate-500 mt-0.5 sm:mt-1">
            {activeTab === 'subscription'
              ? 'Manage your plan, payment method and invoices.'
              : 'Manage your account details and business settings.'}
          </p>
        </div>

        <div className="w-full sm:w-auto flex items-center gap-2 sm:gap-3">
          {activeTab === 'subscription' ? (
            <button
              onClick={() => navigate('/subscription')}
              className="w-full sm:w-auto justify-center px-4 sm:px-5 py-2 sm:py-2.5 text-xs font-semibold text-slate-700 hover:text-[#067978] bg-white hover:bg-slate-50 border border-slate-200 rounded-full transition-all flex items-center gap-2 cursor-pointer shadow-2xs"
            >
              Compare all plans <ChevronRight size={14} />
            </button>
          ) : isEditing ? (
            <>
              <button
                onClick={() => setIsEditing(false)}
                className="flex-1 sm:flex-none px-4 sm:px-5 py-2 sm:py-2.5 text-xs font-semibold text-slate-600 hover:text-slate-900 bg-slate-100 hover:bg-slate-200 rounded-full transition-all cursor-pointer"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="flex-1 sm:flex-none bg-[#067978] hover:bg-[#056362] text-white px-5 sm:px-6 py-2 sm:py-2.5 rounded-full font-semibold text-xs shadow-md shadow-[#067978]/20 flex items-center justify-center gap-2 transition-all hover:scale-105 active:scale-95 cursor-pointer"
              >
                Save Changes
              </button>
            </>
          ) : (
            <button
              onClick={() => setIsEditing(true)}
              className="w-full sm:w-auto justify-center bg-[#067978] hover:bg-[#056362] text-white px-5 sm:px-6 py-2 sm:py-2.5 rounded-full font-semibold text-xs shadow-md shadow-[#067978]/20 flex items-center gap-2 transition-all hover:scale-105 active:scale-95 cursor-pointer"
            >
              Edit Profile
            </button>
          )}
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="w-full p-0.5 sm:p-1 mb-2">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 sm:gap-3 w-full">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab.id)}
                className={`w-full flex items-center justify-center gap-1.5 sm:gap-2 px-2.5 sm:px-4 py-2.5 sm:py-3 rounded-xl sm:rounded-2xl text-[11px] sm:text-xs font-bold tracking-wide transition-all cursor-pointer ${
                  isActive
                    ? 'bg-[#067978] text-white shadow-md shadow-[#067978]/20 ring-2 ring-[#067978]'
                    : 'bg-white text-slate-600 hover:text-slate-900 hover:bg-slate-50 border border-slate-200/80 shadow-2xs'
                }`}
              >
                <Icon size={15} className="shrink-0 sm:w-4 sm:h-4" />
                <span className="truncate">{tab.label}</span>
              </button>
            );
          })}
          <button
            onClick={handleLogout}
            className="w-full flex items-center justify-center gap-1.5 sm:gap-2 px-2.5 sm:px-4 py-2.5 sm:py-3 rounded-xl sm:rounded-2xl text-[11px] sm:text-xs font-bold tracking-wide transition-all cursor-pointer bg-white text-rose-500 hover:text-white hover:bg-rose-500 border border-rose-100 shadow-2xs"
          >
            <LogOut size={15} className="shrink-0 sm:w-4 sm:h-4" />
            <span className="truncate">Logout</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default ProfileHeader;
